import * as atomSkeletons from './AtomSkeletons'
import * as typeSkeletons from './TypeSkeletons'
import * as compoundSkeletons from './CompoundSkeletons'
import * as inputSkeletons from './InputSkeletons'
import BaseSkeleton from './BaseSkeleton'

const Skeleton = {
  ...inputSkeletons,
  ...atomSkeletons,
  ...typeSkeletons,
  ...compoundSkeletons,
  Base: BaseSkeleton,
}

export default Skeleton
